module.exports = __webpack_public_path__ + "videos/galaPowerLevelUp.822c94c.webm";